import Text from 'src/components/Text';
import Lottie from 'react-lottie-player';
import lottieJson from 'src/global/assets/lotties/loadingSpinner.json';

import './styles.css';

interface ISpiner {
  fullContainer?: boolean;
  message?: string;
}

const Spinner = ({ fullContainer = false, message = 'Cargando, por favor espere' }: ISpiner) => {
  return (
    <div 
    className={fullContainer ? 'spinnerFullContainer' : 'spinnerContainer'}
    >
      <Lottie
        loop
        animationData={lottieJson}
        play
        className={'spinner'}
      />
      {message && <div className={'messageStyle'}>
        <Text variant='H2-Regular' textAlign="center">{message}</Text>
      </div>}
    </div>
  );
};

export default Spinner;
